import { useQuery } from "@tanstack/react-query";
import { getTable, QUERY_KEYS, TABLE, type Filters } from "./shared";
import type { DeckIdentifiable } from "../model";
import { getTableRowById } from ":shared/database/get-table";
import { isEmpty, isString } from "lodash-es";

export function useRecords({
	filters = {},
}: {
	initialData?: DeckIdentifiable[];
	filters?: Filters;
	shouldRefetch?: boolean;
} = {}) {
	return useQuery({
		queryKey: QUERY_KEYS.records(filters),
		queryFn: async () => {
			if (isEmpty(filters)) {
				return getTable().toArray();
			}

			const idArr = isString(filters.id) ? [filters.id] : filters.id!;
			return getTable().where("id").anyOf(idArr).toArray();
		},
	});
}

export function getRecordById(id: DeckIdentifiable["id"]) {
	return getTableRowById<DeckIdentifiable, string>({ id, table: TABLE });
}
